import IComponent from "components/commons/IComponent";
import "./GroundProfile.scoped.css";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import "./PanelBase.scoped.css";
import ReactECharts from "echarts-for-react";
import Button from "@material-ui/core/Button";
import geometryTools from "utils/geometryTools";
let _ground_data = null;
class GroundProfile extends IComponent {
  eChartRef = null;
  constructor(props) {
    super(props);
    this.state = {
      outputTable: [],
      GIonLine: [],
      AccumulatedGroundSegment: [],
      isLoading: true,
    };
  }
  componentDidMount() {
    this.ProcessGroundProfile();
    this.props.mapUICallback("DisaleAllWhenShowPanel");
  }
  componentWillUnmount() {}

  downloadcsv() {
    let sb = [];

    //download csv
    let header = "Distance,Elevation\r\n";

    if (_ground_data != null) {
      sb = _ground_data.map((i) => i.attributes.x + "," + i.attributes.y);
    }

    let date = new Date();

    let currentDateTime =
      date.getFullYear() +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
      }) +
      date.getDate().toLocaleString("en-US", { minimumIntegerDigits: 2 }) +
      date.getHours() +
      date.getMinutes();

    this.startDownload(
      header + sb.join("\r\n"),
      currentDateTime + ".csv",
      "data:text/csv;charset=utf-8",
      false
    );
  }

  getChartImage() {
    let echartInstance = this.echartRef.getEchartsInstance();
    let img = new Image();
    img.src = echartInstance.getDataURL();
    let win = window.open("about:blank", "NewWindow");
    win.document.body.appendChild(img);
  }

  startDownload(data, filename, type, isImage) {
    // http://stackoverflow.com/questions/13405129
    var a = document.createElement("a"),
      file = new Blob([data], { type: type });
    // https://msdn.microsoft.com/en-us/library/hh772332(v=vs.85).aspx
    if (window.navigator.msSaveOrOpenBlob)
      // IE10+
      window.navigator.msSaveOrOpenBlob(file, filename);
    else {
      // Others
      var url = isImage ? data : URL.createObjectURL(file);
      a.href = url;
      //"download" is a native HTML5 "A" attribute
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  }

  async ProcessGroundProfile() {
    try {
      let cutLineSymbol = { ...geometryTools.highlightSymbol.polyline };
      cutLineSymbol.width = 1;
      cutLineSymbol.color = [255, 0, 0, 1];
      let pointSymbol = { ...geometryTools.highlightSymbol.point };
      pointSymbol.size = 4;
      pointSymbol.outline = { width: 0 };
      pointSymbol.color = [255, 0, 0, 1];

      this.setState({ isLoading: true });

      let url = this.$config.gpToolUrls.ProjectGroundProfile;
      let params = this.props.params[0];
      let options = {
        userProxy: this.$config.useEsriProxy,
      };

      let GIBuffer_processR = undefined;
      let GIonLine = [];
      let outputTable = [];
      // when tick GI station

      let GroundSegment = await this.props.params[2];
      var AccumulatedGroundSegment = [];
      if (GroundSegment.length > 1) {
        var accumulatedValue = 0;
        GroundSegment.map((element) => {
          accumulatedValue += Math.round(element);
          AccumulatedGroundSegment.push(accumulatedValue);
        });
      }

      if (this.props.GIBuffer) {
        let GI_url = this.$config.gpToolUrls.ProjectGIStation;
        let GI_params = this.props.params[1];

        let updatedParams = {
          Buffer_Distance: params.Buffer_Distance,
          DrawLine: {
            f: "json",
            "env:outSR": 2326,
            geometryType: "esriGeometryPolyline",
            features: [
              {
                geometry: {
                  paths: geometryTools.finetunePolyline(
                    params.DrawLine.features[0].geometry.paths
                  ),
                  spatialReference: {
                    wkid: 2326,
                  },
                },
              },
            ],
            sr: { wkid: 2326 },
          },
        };
        let processR = await geoprocessor.submitJob(
          url,
          updatedParams,
          undefined,
          options
        );
        let updatedGIParams = {
          Buffer_Distance: GI_params.Buffer_Distance,
          DrawLine: {
            f: "json",
            "env:outSR": 2326,
            geometryType: "esriGeometryPolyline",
            features: [
              {
                geometry: {
                  paths: geometryTools.finetunePolyline(
                    GI_params.DrawLine.features[0].geometry.paths
                  ),
                  spatialReference: {
                    wkid: 2326,
                  },
                },
              },
            ],
            sr: { wkid: 2326 },
          },
        };
        let GI_Result = await geoprocessor.submitJob(
          GI_url,
          updatedGIParams,
          undefined,
          options
        );

        // cancel arcgis job purpose
        this.setState({
          outputTable: processR,
          GIonLine: GI_Result,
        });

        let PR = await processR.waitForJobCompletion();
        outputTable = await PR.fetchResultData("outputTable");

        let outputLine = await PR.fetchResultData("outputPoint");
        let mapPoint = outputLine.value.features.map(
          (i) => new geometryTools.Point(i.geometry)
        );
        let lineGraphic = new geometryTools.Graphic({
          symbol: cutLineSymbol,
          geometry: params.DrawLine.features[0].geometry,
        });
        let pointGraphics = mapPoint.map(
          (i) =>
            new geometryTools.Graphic({
              symbol: pointSymbol,
              geometry: i,
            })
        );
        console.debug(lineGraphic, pointGraphics);
        this.props.mapView.graphics.add(lineGraphic);
        this.props.mapView.graphics.addMany(pointGraphics);

        outputTable =
          outputTable.value.features.length === 0
            ? []
            : outputTable.value.features;

        GIBuffer_processR = await GI_Result.waitForJobCompletion();
        GIonLine = await GIBuffer_processR.fetchResultData("GIonLine");
        GIonLine =
          GIonLine.value.features.length === 0 ? [] : GIonLine.value.features;

        GIonLine.length === 0 &&
          this.props.showDialog({
            isOpen: true,
            type: "error",
            title: "No GI stations within buffer !",
            content: "No GI stations within buffer !",
            onDialogOk: () => {},
          });
      } else {
        let updatedParams = {
          f: "json",
          "env:outSR": 2326,
          Buffer_Distance: params.Buffer_Distance,
          DrawLine: {
            geometryType: "esriGeometryPolyline",
            features: [
              {
                geometry: {
                  paths: geometryTools.finetunePolyline(
                    params.DrawLine.features[0].geometry.paths
                  ),
                  spatialReference: {
                    wkid: 2326,
                  },
                },
              },
            ],
            sr: { wkid: 2326 },
          },
        };
        let processR = await geoprocessor.submitJob(
          url,
          updatedParams,
          undefined,
          options
        );

        this.setState({
          outputTable: processR,
          GIonLine: undefined,
        });

        let PR = await processR.waitForJobCompletion();
        outputTable = await PR.fetchResultData("outputTable");

        let outputLine = await PR.fetchResultData("outputPoint");
        let mapPoint = outputLine.value.features.map(
          (i) => new geometryTools.Point(i.geometry)
        );
        let lineGraphic = new geometryTools.Graphic({
          symbol: cutLineSymbol,
          geometry: params.DrawLine.features[0].geometry,
        });
        let pointGraphics = mapPoint.map(
          (i) =>
            new geometryTools.Graphic({
              symbol: pointSymbol,
              geometry: i,
            })
        );
        console.debug(lineGraphic, pointGraphics);
        this.props.mapView.graphics.add(lineGraphic);
        this.props.mapView.graphics.addMany(pointGraphics);

        outputTable =
          outputTable.value.features.length === 0
            ? []
            : outputTable.value.features;
      }

      this.setState(
        {
          outputTable: outputTable,
          GIonLine: GIonLine,
          AccumulatedGroundSegment: AccumulatedGroundSegment,
          isLoading: false,
        }
        // () => {
        //   this.props.resizeWindow(null, true);
        //   this.echartRef.resize();
        // }
      );
    } catch (e) {
      this.props.mapUICallback("hideAllPanel");
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Failed to submit your Ground Profile",
        content: "Error occurred when submiting your Ground Profile",
        jsxElement: e.toString(),
        onDialogOk: () => {},
      });
    }
  }

  getChartOptions(title, data, data2, data3 = []) {
    /*
     data - red line
     data2: blue bar
     data3: green bar
    */

    /* potential code*/
    // let maxAxisValue = Math.max(
    //   Math.max.apply(null, data.map((i) => i.attributes.x)) -
    //     Math.min.apply(null, data.map((i) => i.attributes.x)),
    //   Math.max.apply(null, data.map((i) => i.attributes.y)) -
    //     Math.min.apply(null, data.map((i) => i.attributes.y))
    // );
    // let maxAxisValue = Math.max(
    //   Math.max.apply(null, data.map((i) => i.attributes.x)),
    //   Math.max.apply(null, data.map((i) => i.attributes.y))
    // );

    // X must be started from 0
    let xSpread =
      // Math.max.apply(null, data.map((i) => i.attributes.x)) -
      // Math.min.apply(null, data.map((i) => i.attributes.x));
      Math.max.apply(null, data.map((i) => i.attributes.x));

    let ySpread =
      Math.max.apply(null, data.map((i) => i.attributes.y)) -
      Math.min.apply(null, data.map((i) => i.attributes.y));

    let maxAxisValue = Math.max(
      // xSpread > ySpread
      //   ? Math.max.apply(null, data.map((i) => i.attributes.x))
      //   : Math.max.apply(null, data.map((i) => i.attributes.y))
      xSpread,
      ySpread
    );
    let FinalV = this.maxV(data2, data);

    // depth to be consider as range of max xAxis (Spread)
    let GIBuffer_V = Math.max(
      ...data2.map((i) =>
        // parseFloat(i.attributes.GRDLEVEL) -
        parseFloat(i.attributes.DEPTH)
      )
    );

    let AccumulatedGroundSegmentLength =
      this.state.AccumulatedGroundSegment.length > 1
        ? Math.max.apply(
            null,
            // data3.map((i) => [i, Math.ceil(FinalV / 10) * 10]).flat()
            data3
          )
        : -1;

    // console.log(data3);

    // compare which value are largest
    // maxAxisValue = this.props.GIBuffer
    //   ? maxAxisValue > GIBuffer_V
    //     ? maxAxisValue
    //     : GIBuffer_V
    //   : maxAxisValue;

    maxAxisValue = Math.max(
      maxAxisValue, // data x, y
      Math.max(
        Math.max.apply(null, data2.map((i) => i.attributes.x)),
        GIBuffer_V
      ), // data2 x, y
      AccumulatedGroundSegmentLength // data3 x (y is followed maxAxisValue)
    );

    // remove original logic of 1:1
    // maxAxisValue = maxAxisValue + (50 - (maxAxisValue % 50));

    let minX = Math.min(
      Math.min.apply(null, data.map((i) => i.attributes.x)),
      Math.min.apply(null, data2.map((i) => i.attributes.x))
    );

    _ground_data = data;

    var AxRg = this.findRange(
      data.map((i) => ({
        x: parseFloat(i.attributes.x),
        y: parseFloat(i.attributes.y),
      }))
    );

    // AxRg[1] = -100;

    let a = [
      {
        data: [],
        type: "line",
        itemStyle: {
          color: "#FF0000",
        },
      },
      {
        data: [],
        type: "bar",
        barWidth: 1, // Set the bar width to 1
        itemStyle: {
          color: "#7CFC00",
        },
      },
      ...data2
        .filter(
          (i) =>
            i.attributes.DEPTH.trim() !== "" ||
            i.attributes.GRDLEVEL.trim() !== ""
        )
        .map((i, index) => ({
          data: [
            [
              i.attributes.x,
              parseFloat(i.attributes.GRDLEVEL) -
                parseFloat(i.attributes.DEPTH),
            ],
            [i.attributes.x, parseFloat(i.attributes.GRDLEVEL)],
          ],
          type: "line",
          itemStyle: {
            color: "#0000FF",
          },
          endLabel: {
            show: true,
            formatter: function(params) {
              return (
                data2[index].attributes.REPNO +
                " / " +
                data2[index].attributes.STATNO +
                "(" +
                Math.ceil(data2[index].attributes.PRJDIST * 10) / 10 +
                ")"
              );
            },
            offset: [-40, -10], // horizontal, veritcal
          },
        })),
    ];

    let aa = [
      {
        data: [],
        type: "line",
        itemStyle: {
          color: "#FF0000",
        },
      },
      {
        data: [],
        type: "bar",
        barWidth: 1, // Set the bar width to 1
        itemStyle: {
          color: "#7CFC00",
        },
      },
      {
        data: [],
        type: "bar",
        barWidth: 1, // Set the bar width to 1
        itemStyle: {
          color: "#7CFC00",
        },
      },
      ...data2
        .filter(
          (i) =>
            i.attributes.DEPTH.trim() !== "" ||
            i.attributes.GRDLEVEL.trim() !== ""
        )
        .map((i, index) => ({
          data: [
            [
              i.attributes.x,
              parseFloat(i.attributes.GRDLEVEL) -
                parseFloat(i.attributes.DEPTH),
            ],
            [i.attributes.x, parseFloat(i.attributes.GRDLEVEL)],
          ],
          type: "line",
          itemStyle: {
            color: "#0000FF",
          },
          endLabel: {
            show: true,
            formatter: function(params) {
              return (
                data2[index].attributes.REPNO +
                " / " +
                data2[index].attributes.STATNO +
                "(" +
                Math.ceil(data2[index].attributes.PRJDIST * 10) / 10 +
                ")"
              );
            },
            offset: [-40, -10], // horizontal, veritcal
          },
        })),
    ];

    let b = [
      {
        data: [],
        type: "line",
        itemStyle: {
          color: "#FF0000",
        },
      },
      {
        data: [],
        type: "bar",
        barWidth: 1, // Set the bar width to 1
        itemStyle: {
          color: "#7CFC00",
        },
      },
    ];

    let bb = [
      {
        data: [],
        type: "line",
        itemStyle: {
          color: "#FF0000",
        },
      },
      {
        data: [],
        type: "bar",
        barWidth: 1, // Set the bar width to 1
        itemStyle: {
          color: "#7CFC00",
        },
      },
      {
        data: [],
        type: "bar",
        barWidth: 1, // Set the bar width to 1
        itemStyle: {
          color: "#7CFC00",
        },
      },
    ];

    const CHART_OPTIONS = {
      //   title: {
      //     left: "center",
      //   },

      grid: { top: 10, bottom: 60, right: 10, left: 60 },

      tooltip: {
        show: true,

        trigger: "axis",

        formatter: "{c}<br/>{b}",
      },

      xAxis: {
        type: "value",
        name: "Distance (m)",
        nameLocation: "middle",
        nameTextStyle: { lineHeight: 56 },
        // min: 0, //Math.floor(minX / 10) * 10,
        // max: Math.ceil(maxAxisValue / 10) * 10,
        minInterval: 1,

        min: AxRg[0],
        max: AxRg[2],
        // Math.max.apply(null, data.map((i) => i.attributes.x)) >
        // Math.max.apply(null, data.map((i) => i.attributes.y))
        //   ? Math.ceil(maxAxisValue / 10) * 10
        //   : Math.floor(this.minV(data2, data) / 10) * 10 +
        //     (Math.ceil(maxAxisValue / 10) * 10 - Math.floor(minX / 10) * 10),
      },

      yAxis: {
        type: "value",
        name: "Elevation (mPD)",
        nameLocation: "middle",
        nameTextStyle: { lineHeight: 56 },
        // min: Math.floor(this.minV(data2, data) / 10) * 10,
        // max:
        //   Math.floor(this.minV(data2, data) / 10) * 10 +
        //   (Math.ceil(maxAxisValue / 10) * 10 - Math.floor(minX / 10) * 10),
        min: AxRg[1],
        max: AxRg[3],
        // Math.max.apply(null, data.map((i) => i.attributes.x)) <=
        // Math.max.apply(null, data.map((i) => i.attributes.y))
        //   ? Math.ceil(maxAxisValue / 10) * 10
        //   : Math.floor(this.minV(data2, data) / 10) * 10 +
        //     (Math.ceil(maxAxisValue / 10) * 10 - Math.floor(minX / 10) * 10),
      },

      series:
        this.props.GIBuffer && this.state.GIonLine.length > 0
          ? AxRg[1] < 0
            ? aa
            : a
          : AxRg[1] < 0
          ? bb
          : b,
      dataZoom: [
        {
          type: "inside",
          start: 0,
          end: 100,
        },
      ],
    };

    let options = CHART_OPTIONS;
    options.xAxis.data = this.state.outputTable;
    options.series[0].data = data.map((i) => [i.attributes.x, i.attributes.y]);
    // console.log(FinalV);

    options.series[1].data =
      this.state.AccumulatedGroundSegment.length > 1
        ? //data3.map((i) => [i, Math.ceil(FinalV / 10) * 10])
          data3.map((i) => [
            i,
            // Math.floor(this.minV(data2, data) / 10) * 10 +
            //   (Math.ceil(maxAxisValue / 10) * 10 - Math.floor(minX / 10) * 10),
            AxRg[3],
          ])
        : [];

    // if data min < 0
    if (AxRg[1] < 0) {
      options.series[2].data =
        this.state.AccumulatedGroundSegment.length > 1
          ? //data3.map((i) => [i, Math.ceil(FinalV / 10) * 10])
            data3.map((i) => [
              i,
              // Math.floor(this.minV(data2, data) / 10) * 10 +
              //   (Math.ceil(maxAxisValue / 10) * 10 - Math.floor(minX / 10) * 10),
              AxRg[1],
            ])
          : [];
    }

    // console.log("check data", data, data2, data3);
    // options.series[1].data =
    //   this.state.AccumulatedGroundSegment.length > 1
    //     ? data3.map((i) => [i, SecmaxAxisValue])
    //     : [];

    // if (this.state.AccumulatedGroundSegment.length > 1) {
    //   options.xAxis.max = SecmaxAxisValue;
    // }

    return options;
  }

  maxV(data2, data) {
    let MaxGLineLength =
      this.props.GIBuffer && this.state.GIonLine.length > 0
        ? Math.max(...data2.map((i) => parseFloat(i.attributes.GRDLEVEL)))
        : 0;
    let maxSegmentLength = Math.max(...data.map((i) => i.attributes.y));
    let FinalV =
      maxSegmentLength > MaxGLineLength ? maxSegmentLength : MaxGLineLength;

    return 1.1 * FinalV; // adjust Value
  }

  minV(data2, data) {
    let MinGLineLength =
      this.props.GIBuffer && this.state.GIonLine.length > 0
        ? Math.min(
            ...data2.map(
              (i) =>
                parseFloat(i.attributes.GRDLEVEL) -
                parseFloat(i.attributes.DEPTH)
            )
          )
        : 99999;
    let minSegmentLength = Math.min(...data.map((i) => i.attributes.y));
    let FinalV =
      this.props.GIBuffer && this.state.GIonLine.length > 0
        ? minSegmentLength < MinGLineLength
          ? minSegmentLength
          : MinGLineLength
        : minSegmentLength;

    // console.log(MinGLineLength, minSegmentLength);

    return FinalV * 0.9; // adjust Value
  }

  findRange(pLn) {
    var maxVx = -1;
    var maxVy = -1;
    var minVx = 20000;
    var minVy = 20000;
    for (let i = 0; i < pLn.length; i++) {
      if (pLn[i].x > maxVx) {
        maxVx = pLn[i].x;
      }
      if (pLn[i].x < minVx) {
        minVx = pLn[i].x;
      }
      if (pLn[i].y > maxVy) {
        maxVy = pLn[i].y;
      }
      if (pLn[i].y < minVy) {
        minVy = pLn[i].y;
      }
    }
    var rFactor = this.getRangeFactor(minVx, maxVx, minVy, maxVy);
    return this.getFRange(minVx, maxVx, minVy, maxVy, rFactor);
  }

  getRangeFactor(p11, p12, p21, p22) {
    //min_x, max_x, min_y, max_y
    var max_Rg = Math.max(
      Math.log(p12 - p11) / Math.log(10),
      Math.log(p22 - p21) / Math.log(10)
    );
    return Math.pow(10, Math.floor(max_Rg));
  }

  getFRange(p11, p12, p21, p22, rFact) {
    //min_x, max_x, min_y, max_y, range factor
    var rang, maxRg;
    var x1 = Math.floor(p11 / rFact) * rFact;
    var x2 = Math.ceil(p12 / rFact) * rFact;
    var y1 = Math.floor(p21 / rFact) * rFact;
    var y2 = Math.ceil(p22 / rFact) * rFact;
    if (x2 - x1 > y2 - y1) {
      maxRg = x2 - x1;
      rang = [x1, y1, x2, y1 + maxRg];
    } else if (y2 - y1 > x2 - x1) {
      maxRg = y2 - y1;
      rang = [x1, y1, x1 + maxRg, y2];
    } else {
      rang = [x1, y1, x2, y2];
    }
    return rang;
  }

  render() {
    let {
      outputTable,
      GIonLine,
      AccumulatedGroundSegment,
      isLoading,
    } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Ground Profile</span>
          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={async () => {
              this.props.mapUICallback("hideAllPanel");

              isLoading && (await outputTable.cancelJob(outputTable.jobId));
              isLoading &&
                (GIonLine !== undefined &&
                  (await GIonLine.cancelJob(GIonLine.jobId)));
            }}
          />
        </div>
        <div className="ChartsContainer">
          {isLoading && (
            <div className="SubPanelContent">
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <span className="icn_loading" /> Refreshing your charts...
              </div>
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                ***Close the window to cancel process***
              </div>
            </div>
          )}
          {outputTable.length <= 0 && GIonLine.length <= 0
            ? !isLoading && <div>No data</div>
            : !isLoading && (
                <div className="Toolbar AlignRight">
                  <Button
                    style={{ margin: "10px" }}
                    onClick={() => {
                      this.getChartImage();
                    }}
                  >
                    <span className="icn_tool_Elevationprofile" />
                  </Button>{" "}
                  <Button
                    style={{ margin: "10px" }}
                    onClick={() => {
                      this.downloadcsv();
                    }}
                  >
                    <span className="icn_3d_Elevationprofile_export" />
                  </Button>
                </div>
              )}
          <div style={{ height: "calc(100% - 70px)" }}>
            {outputTable.length <= 0 && GIonLine.length <= 0
              ? !isLoading && (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                    }}
                  >
                    No data
                  </div>
                )
              : !isLoading && (
                  <ReactECharts
                    ref={(e) => {
                      if (!this.echartRef) {
                        this.echartRef = e;
                      }
                    }}
                    style={{
                      height: "100%",
                      zoom: "125%",
                      aspectRatio: "1 / 1",
                    }}
                    option={this.getChartOptions(
                      "",
                      outputTable,
                      GIonLine,
                      AccumulatedGroundSegment
                    )}
                    autoResize={true}
                  />
                )}
          </div>
        </div>
      </div>
    );
  }
}

export default GroundProfile;
